module.exports = __webpack_public_path__ + "img/mealreminder-text.58490d18.png";